//constants
import {DELETE_UPPER, DETAILS} from '@/utils/constants';

export const tableContactsMenuContent = [DETAILS, DELETE_UPPER];
